import { Authorisation } from "@iventis/domain-model/model/authorisation";

export const permissableAuthorisations = [Authorisation.Read, Authorisation.Write, Authorisation.Admin];

export const AuthorisationPrecedenceOrder = [Authorisation.None, Authorisation.Read, Authorisation.Write, Authorisation.Admin];

export const isAllowed = (actual: Authorisation, expected: Authorisation) => {
    const actualPrecedence = AuthorisationPrecedenceOrder.indexOf(actual);
    const expectedPrecedence = AuthorisationPrecedenceOrder.indexOf(expected);
    if (actualPrecedence === -1 || expectedPrecedence === -1) {
        throw new Error("Actual or Expected permission not found");
    }
    return actualPrecedence >= expectedPrecedence;
};
